import React, { createContext, useContext } from "react";

export interface UiMessages {
  dialog: {
    confirm: string;
    cancel: string;
    closeAlert: string;
    closeConfirm: string;
  };
  pagination: {
    label: string;
    previousPage: string;
    nextPage: string;
    pageLabel: (page: number) => string;
    pageInfo: (start: number, end: number, total: number) => string;
  };
}

export const defaultUiMessages: UiMessages = {
  dialog: {
    confirm: "Confirm",
    cancel: "Cancel",
    closeAlert: "Close alert",
    closeConfirm: "Close confirmation dialog",
  },
  pagination: {
    label: "Pagination",
    previousPage: "Previous page",
    nextPage: "Next page",
    pageLabel: (page) => `Page ${page}`,
    pageInfo: (start, end, total) => `Showing ${start} to ${end} of ${total} items`,
  },
};

const UiMessagesContext = createContext<UiMessages>(defaultUiMessages);

export interface UiMessagesProviderProps {
  messages: UiMessages;
  children: React.ReactNode;
}

export const UiMessagesProvider: React.FC<UiMessagesProviderProps> = ({ messages, children }) => (
  <UiMessagesContext.Provider value={messages}>{children}</UiMessagesContext.Provider>
);

export const useUiMessages = (): UiMessages => useContext(UiMessagesContext);
